import React from 'react';
import { ReactComponent as PlusIcon } from '../../../../images/icons/add.svg';
import { PopoverOption } from '../../../../shared/PopoverMenu';
import { TreeNodeType } from './treeNode';
import { Popover } from './Popover';

type Props = {
  addChildOfNodeType: (nodeType: TreeNodeType) => void;
  showAddManifold: boolean;
  testId: string;
  className?: string;
};

export const PlusPopover = ({ addChildOfNodeType, testId, showAddManifold, className }: Props) => {
  const getAddChildCallback = (nodeType: TreeNodeType) => {
    return () => {
      addChildOfNodeType(nodeType);
    };
  };

  const getOption = (name: string, nodeType: TreeNodeType): PopoverOption => ({
    name,
    dataTestId: pipePlusMenuItemTestId(testId, nodeType),
    onClick: getAddChildCallback(nodeType),
    icon: 'Plus',
  });

  const options = [
    getOption('Add junction', TreeNodeType.Junction),
    getOption('Add pump', TreeNodeType.Pump),
    ...(showAddManifold ? [getOption('Add manifold', TreeNodeType.Manifold)] : []),
  ];

  const tooltipLabel = showAddManifold ? 'Add a junction, pump or manifold' : 'Add a junction or pump';

  return (
    <Popover
      tooltipLabel={tooltipLabel}
      icon={<PlusIcon title={tooltipLabel} />}
      options={options}
      className={className}
      testId={testId}
    />
  );
};

export const pipePlusMenuItemTestId = (pipeTestId: string, category: TreeNodeType) =>
  `${pipeTestId}-add-${category.toString()}`;
